<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
    <!--<img *ngIf="icon" alt="Confirmation icon" [src]="icon" class="icon" />-->
    <div class="error-icon">
        <div class="content">×
        </div>
    </div>
    <p *ngIf="message" [innerHtml]="message"></p>

    <ng-scrollbar *ngIf="elementList.length>0">
        <p class="elementlist-element" *ngFor="let element of elementList">{{ element }}</p>
    </ng-scrollbar>

    <form class="show-more" *ngIf="showMoreTitle" [ngClass]="{'show-more-state': showMoreState}">
        <button class="opener-button" (click)="showMoreState=!showMoreState">
            <div class="opener-text">{{ showMoreTitle }}</div>
            <img class="opener-icon" src="assets/icons/arrow-down.svg">
        </button>
        <div *ngIf="showMoreState" class="show-more-area">
            <textarea readonly>{{ showMoreValue }}</textarea>
            <button class="copy-to-clipboard" (click)="copyToClipboardClick()" [ngClass]="{'copy-animation': copyAnimation}">
                <span *ngIf="!copyAnimation">
                    <img src="assets/icons/copy-link.svg"/> {{ languageService.languageJSON.Global_CopyToClipboard }}
                </span>
                <span *ngIf="copyAnimation">
                    <img src="assets/icons/check-mark-line.svg">
                    {{ languageService.languageJSON.Global_CopyAnimation_Text }}
                </span>
                
            </button>
        </div>

        
    </form>
    
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ languageService.languageJSON.Global_Close }}</button>
</div>